import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhyChoose from "@/components/WhyChoose";
import Collections from "@/components/Collections";
import Pricing from "@/components/Pricing";
import HowItWorks from "@/components/HowItWorks";
import Gallery from "@/components/Gallery";
import Trust from "@/components/Trust";
import About from "@/components/About";
import ServingTeams from "@/components/ServingTeams";
import CTASection from "@/components/CTASection";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import FloatingCTA from "@/components/FloatingCTA";
import SEOHead from "@/components/SEOHead";
import BlogTeaser from "@/components/BlogTeaser";
import { CORE_KEYWORDS, joinKw } from "@/config/keywords";

const HERO_POLO =
  "https://customer-assets.emergentagent.com/job_custom-team-jerseys-1/artifacts/cnhyrmrv_Samoan%20Church%20Uniforms.png";
const COLLECTION_CHOIR =
  "https://customer-assets.emergentagent.com/job_custom-team-jerseys-1/artifacts/umipod3h_Samoan%20church%20choir%20uniform%20polo%20shirt.png";
const COLLECTION_YOUTH =
  "https://customer-assets.emergentagent.com/job_custom-team-jerseys-1/artifacts/czetrdap_Youth%20ministry%20polo%20shirt%20uniform.png";
const COLLECTION_REUNION =
  "https://customer-assets.emergentagent.com/job_custom-team-jerseys-1/artifacts/yzzktg66_Family%20reunion%20uniform%20polo%20shirt.png";

export default function LandingPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Tribal Designz",
    alternateName: "Pacific Heritage Uniforms",
    "@id": "https://tribaldesignz.com",
    url: "https://tribaldesignz.com",
    telephone: "+64 22 101 2443",
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Auckland",
      addressRegion: "Auckland",
      addressCountry: "NZ",
    },
    areaServed: [
      { "@type": "City", name: "Auckland" },
      { "@type": "Country", name: "New Zealand" },
    ],
    sameAs: [
      "https://www.tiktok.com/@tribaldesignzco",
      "https://instagram.com/tribaldesignznz",
    ],
    description:
      "Custom Samoan, Tongan and Cook Islands polo uniforms for Pacific churches, ministries, choirs, conferences and reunion groups across Auckland and New Zealand.",
    knowsAbout: [
      "Samoan Church Uniforms", "Tongan Church Uniforms", "Cook Islands Church Uniforms",
      "Church Choir Uniforms", "Pacific Heritage Uniforms", "Custom Church Polo Shirts",
      "Family Reunion Polo Shirts", "Church Conference Uniforms",
    ],
  };

  const imageObjects = [
    {
      url: HERO_POLO,
      alt: "Samoan Church Uniforms — group in custom Pacific heritage polo shirts with red lei and tatau patterns, Auckland NZ",
      name: "Samoan Church Uniforms — Heritage Polo Group",
      representative: true,
    },
    {
      url: COLLECTION_CHOIR,
      alt: "Samoan Church Choir Uniforms — choir singing in matching white red and blue Pacific polo shirts, Custom Choir Uniforms NZ",
      name: "Church Unity Collection — Samoan Choir Uniforms",
    },
    {
      url: COLLECTION_YOUTH,
      alt: "Pacific Youth Ministry Uniforms — youth volunteers serving community in custom Pasifika polo shirts, Conference Excellence Collection",
      name: "Conference Excellence Collection — Youth Ministry Polos",
    },
    {
      url: COLLECTION_REUNION,
      alt: "Samoan Family Reunion Polo Shirts — Manu'a family reunion in coordinated Pacific heritage uniforms, Reunion Legacy Collection",
      name: "Reunion Legacy Collection — Family Reunion Polos",
    },
  ];

  return (
    <main className="bg-zinc-950 text-white min-h-screen overflow-x-hidden" data-testid="landing-page">
      <SEOHead
        title="Pacific Church Uniforms NZ | Samoan Tongan Cook Islands Polos"
        description="Custom Samoan, Tongan & Cook Islands church polo uniforms for choirs, ministries, conferences & reunions across NZ. Auckland-based Pasifika studio. Free mockup in 24h."
        path="/"
        image={HERO_POLO}
        imageAlt="Samoan Church Uniforms — custom Pacific polo shirts Auckland NZ"
        keywords={joinKw(CORE_KEYWORDS)}
        jsonLd={jsonLd}
        imageObjects={imageObjects}
      />
      <Navbar />
      <Hero />
      <WhyChoose />
      <Collections />
      <Pricing />
      <HowItWorks />
      <Gallery />
      <Trust />
      <About />
      <ServingTeams />
      <CTASection />
      <ContactForm />
      <Footer />
      <FloatingCTA />
    </main>
  );
}
